// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import type { ImageSourcePropType } from 'react-native';

import { extractImageVersion } from './imageVersion';
import { getConfiguredAssetBaseUrl } from './mediaUrl';

type AvatarPlayer = {
  id?: string | null;
  imageKey?: string | null;
  imageThumbKey?: string | null;
};

const avatarSourceCache = new Map<string, ImageSourcePropType>();

export const getPlayerAvatarImageSource = (apiBaseUrl: string, player: AvatarPlayer): ImageSourcePropType | null => {
  const playerId = player.id?.trim();
  const imageReference = player.imageThumbKey ?? player.imageKey ?? null;
  if (!playerId || !imageReference) {
    return null;
  }

  // Prefer the CDN when one is configured: the BFF route is anonymous and immutable, so
  // serving it from the edge skips a player-service lookup and an S3 read per avatar.
  // `variant` is part of the CloudFront cache key — see the frontend-assets Pulumi stack.
  const normalizedBaseUrl = getConfiguredAssetBaseUrl() ?? apiBaseUrl.replace(/\/+$/, '');
  const variant = player.imageThumbKey ? 'thumb' : 'main';
  const version = extractImageVersion(imageReference);
  const uri =
    `${normalizedBaseUrl}/api/players/${encodeURIComponent(playerId)}/image` +
    `?variant=${encodeURIComponent(variant)}&v=${encodeURIComponent(version)}`;

  const cached = avatarSourceCache.get(uri);
  if (cached) {
    return cached;
  }

  const source = { uri };
  avatarSourceCache.set(uri, source);
  return source;
};

